<aside class="extra-info-header">
  <button
    data-testid="btn-extra-info-back-to-records"
    type="button"
    class="extra-info-header__back-button"
    aria-label="Home"
    (click)="goChooseRecords()"
    (keydown.enter)="goChooseRecords()">
    <icon-display iconName="arrow-left" [height]="24" [width]="24" />
  </button>
  <div class="extra-info-header__info">
    <span class="extra-info-header__info__count">
      {{
        "ExtraInfoHeaderComponent.RecordsCount"
          | translate: { count: recordQuantity }
      }}
    </span>
    <div
      class="extra-info-header__info__text"
      data-testid="current-record-info">
      <span class="extra-info-header__info__text__current-record-info">
        {{ currentRecordInfo }}
      </span>
      @if (requesterIsNotClient) {
        <div class="extra-info-header__info__text__requester">
          <icon-display
            class="extra-info-header__info__text__requester__icon"
            iconName="user"
            [height]="20"
            [width]="20" />
          <span>
            {{ `${record.requesterName ?? ""} ${record.requesterFamilyName1 ?? ""} ${record.requesterFamilyName2 ?? ""}`.trim() }}
          </span>
        </div>
      }
    </div>
  </div>
</aside>
